import { ACTION_TYPE } from '../../../core/redux/actionType';
import { IAppState } from '../../../core/redux/IAppState';
import { Action } from 'redux';
import { assoc } from '../../../language/module';


/**
 * Creates an action that you can dispatch to clear out the currently redeemed entitlements if it exists in app state.
 */
export const clearRedeemedEntitlementAction = () => ({ type: ACTION_TYPE.CLEAR_REDEEMED_ENTITLEMENT });


/**
 * Reducer that clears out the currently redeemed entitlements (if it exists in app state) and returns a new app state.
 */
export const clearRedeemedEntitlementReducer = (state: IAppState, action: Action) => {
  if (action.type !== ACTION_TYPE.CLEAR_REDEEMED_ENTITLEMENT) {
    return state;
  }

  return assoc('redeemedEntitlement', undefined, state);
};
